// extracted by mini-css-extract-plugin
export default {"root":"CheckboxGroup-module__root___AIFFQ"};